"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a course enrollment field failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class CourseEnrollmentBodyNotValidError extends client_library_1.ExtendableError {
    constructor(field, message) {
        super(`course enrollment: ${field} failed validation. ${message}`);
        this.field = field;
    }
}
exports.default = CourseEnrollmentBodyNotValidError;
//# sourceMappingURL=CourseEnrollmentBodyNotValidError.js.map